import * as React from 'react';
import * as styles from './styles.css';

import { identity } from 'ramda';
import { Spinner } from '@cian/ui-kit';

import { ResultReportDescription } from './components';
import { IMarketPriceProps } from './types';
import { ObjectInfoContainer } from '../../containers/ObjectInfoContainer';

type TMarketPriceProps = IMarketPriceProps & {
  ref?: React.Ref<HTMLDivElement>;
};

export function MarketPrice(props: TMarketPriceProps): React.JSX.Element {
  const { isFetching, isReportResultDescriptionVisible, preciseFilters, priceAverage, isDesktop, ref } = props;

  return (
    <div>
      <div ref={ref} className={styles['container']} data-testid="market_price">
        {isDesktop && <ObjectInfoContainer refWrapper={identity} />}
        <div className={styles['result']}>
          {isFetching && (
            <div className={styles['preloader']} data-testid="market_price_preloader_overlay">
              <Spinner size={32} />
            </div>
          )}
          <div className={styles['description']}>{priceAverage}</div>
        </div>

        {isReportResultDescriptionVisible && (
          <div className={styles['result-report-description']}>
            <ResultReportDescription />
          </div>
        )}

        {preciseFilters}
      </div>
    </div>
  );
}
